export let PractitionerLevel = /*#__PURE__*/function (PractitionerLevel) {
  PractitionerLevel["CHIEF"] = "CHIEF";
  PractitionerLevel["SENIOR"] = "SENIOR";
  PractitionerLevel["JUNIOR"] = "JUNIOR";
  PractitionerLevel["GRADUATE"] = "GRADUATE";
  return PractitionerLevel;
}({});
export let PractitionerRole = /*#__PURE__*/function (PractitionerRole) {
  PractitionerRole["NONE"] = "NONE";
  PractitionerRole["ASSISTANT"] = "ASSISTANT";
  PractitionerRole["ACCOUNTANT"] = "ACCOUNTANT";
  PractitionerRole["HYGIENIST"] = "HYGIENIST";
  PractitionerRole["DENTIST"] = "DENTIST";
  PractitionerRole["CLINIC_MANAGER"] = "CLINIC_MANAGER";
  PractitionerRole["RECEPTIONIST"] = "RECEPTIONIST";
  PractitionerRole["DENTAL_TECHNICIAN"] = "DENTAL_TECHNICIAN";
  return PractitionerRole;
}({});
export let CvEntryEducationType = /*#__PURE__*/function (CvEntryEducationType) {
  CvEntryEducationType["EDUCATION"] = "EDUCATION";
  CvEntryEducationType["PROFESSIONAL_EXPERIENCE"] = "PROFESSIONAL_EXPERIENCE";
  CvEntryEducationType["CERTIFICATE"] = "CERTIFICATE";
  return CvEntryEducationType;
}({});